export default {"src":"/_next/static/media/gmail.6c9a15f8.svg","height":35,"width":35};